// src/utils/getFontValue.ts
import { useTheme, type Theme, type TypographyStyle } from '@mui/material/styles';

import useResponsive from '../hooks/useResponsive';

// ----------------------------------------------------------------------

// ← here’s the only change you need:
type Variant = keyof Theme['typography'];

// ----------------------------------------------------------------------

export default function GetFontValue(variant: Variant) {
  const theme = useTheme();
  const breakpoints = useWidth();
  const key = theme.breakpoints.up(breakpoints === 'xl' ? 'lg' : breakpoints);

  // cast the raw variant to the known shape
  const raw = theme.typography[variant] as unknown as TypographyStyle;
  const font = (raw as any)[key] ?? raw;

  const fontSize = remToPx(font.fontSize);
  const lh = font.lineHeight;
  const lineHeight = typeof lh === 'number' ? lh * fontSize : Number(lh) * fontSize;
  const { fontWeight, letterSpacing } = font;

  return { fontSize, lineHeight, fontWeight, letterSpacing };
}

// ----------------------------------------------------------------------

export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }: { sm: number; md: number; lg: number }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

// ----------------------------------------------------------------------

function useWidth() {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    // @ts-ignore not sure what is this
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useResponsive('up', key);
      return !output && matches ? key : output;
    }, null) || 'xs'
  );
}
